export const CAPTION_NODE_NAME = 'caption-node-name';

export enum OutRefBookmarkKind {
  FIGURE = 'FIGURE',
  TABLE = 'TABLE',
}

/** Type guard to validate caption kind values */
export const isValidCaptionKind = (kind: unknown): kind is OutRefBookmarkKind =>
  typeof kind === 'string' && Object.values(OutRefBookmarkKind).includes(kind as OutRefBookmarkKind);
